import { headlines, recallItems } from "@/mocks/home";

export default function HeadlineFeed() {
  return (
    <section id="headlines" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-page px-4 py-8 md:px-6 md:py-12">
        <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-newspaper-line text-secondary-700" />
              今日要闻
            </span>
            <h2 className="mt-3 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              头条与今日要闻
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
              标题加短摘要的紧凑排列，不点开也能知道今天的头条在讲什么。
            </p>
          </div>
          <a
            href="#rank"
            className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-100 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            看完整热瓜榜
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-8">
            <ul className="border-t border-background-200">
              {headlines.map((item, index) => (
                <li
                  key={item.title}
                  className="group flex cursor-pointer gap-3.5 border-b border-background-200 py-4 md:gap-5 md:py-5"
                >
                  <span className="w-8 shrink-0 font-heading text-lg text-background-400 md:text-xl">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-primary-50 px-2.5 py-0.5 text-xs text-primary-700">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.source}</span>
                    </div>
                    <h3 className="mt-2 font-heading text-lg leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                      {item.summary}
                    </p>
                    <div className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line" />
                        {item.time}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-chat-3-line" />
                        {item.comments} 条讨论
                      </span>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <aside className="flex flex-col gap-4 lg:col-span-4">
            <div className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
                <i className="ri-history-line text-accent-600" />
                昨日要闻回顾
              </h3>
              <ul className="mt-3 flex flex-col divide-y divide-background-200">
                {recallItems.map((item) => (
                  <li key={item.title} className="py-3 first:pt-0">
                    <a
                      href="#headlines"
                      className="group flex cursor-pointer flex-col gap-1"
                    >
                      <p className="line-clamp-2 text-sm leading-relaxed text-foreground-800 transition-colors group-hover:text-primary-600">
                        {item.title}
                      </p>
                      <span className="text-xs text-foreground-400">{item.time}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-secondary-200 bg-secondary-50 p-4 md:p-5">
              <h3 className="flex items-center gap-2 font-heading text-lg text-secondary-900">
                <i className="ri-quill-pen-line text-secondary-600" />
                编辑手记
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-700">
                今天的头条集中在几件事上，共同点是「细节对不上」。我们按时间把可信度较高的部分排在前面，
                存疑的位置也都标了出来，方便你按自己的节奏判断。
              </p>
              <div className="mt-3.5 flex items-center gap-2 border-t border-secondary-200 pt-3">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-500 text-sm text-background-50">
                  编
                </span>
                <div className="leading-tight">
                  <p className="text-sm text-foreground-800">值班编辑</p>
                  <p className="text-xs text-foreground-500">今日 09:20 更新</p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}